// extracted by mini-css-extract-plugin
export default {"main_info":"styles_main_info__4JJNx","name":"styles_name__yzQu8","divider":"styles_divider__Xr+Mx"};